const assignment = {
  assignment: "Assignment",
  create: "Create a new assignment",
  creation: "Create assignment",
  update: "Edit assignment",
  view: "Assignment overview",
  creationInstruction: "Configure your assignment settings.",
  number: "No.",
  name: "Name",
  lastEdited: "Last modified",
  classes: "Classes",
  follow: "My assignments",
  followed: "My assignments",
  finishDate: "Due date",
  mandatoryStartDate: "Start date is required.",
  mandatoryFinishDate: "Due date is required.",
  finishDateCondition:
    "The due date must be later than the start date and today’s date.",
  save: "Save",
  saveAndPublish: "Save and publish",
  selectExercisesInstruction:
    "Select the exercises you want to add to your assignment by clicking the icons.",
  visualizeHomeworkInstruction: "Preview your assignment before saving it.",
  teacherNoHomework: "You haven’t created any assignments yet.",
  deleteHomeworkQuestion: "Delete this assignment?",
  deleteHomeworkDescription:
    "This assignment will no longer be available. All assignment data will be permanently deleted.",
  notOpened: "Not started",
  notCompleted: "Incomplete",
  noGradeNotCompleted: "Incomplete",
  homeworkNotOpened: "Assignment not started",
  homeworkNotFinished: "Assignment incomplete",
  all_levels: "All levels",
  followMyHomeworks: "My assignments",
  homework: "Assignment",
  mockTest: "Mock test",
  mockTestNumber: "Mock Test No.",
  completeHomework: "Complete the assignment",
  completeHomeworkAgain: "Retake the assignment",
  mockTestName: "Mock test name: ",
  homeworkName: "Assignment name: ",
  homeworkStartDate: "Start date",
  homeworkFinishDate: "Deadline",
  homeworkStatus: "Status",
  homeworkStartDateWithColon: "Start date: ",
  homeworkFinishDateWithColon: "Deadline: ",
  homeworkStatusWithColon: "Status: ",
  homeworkStatusComing: "Upcoming",
  homeworkStatusOngoing: "Open",
  homeworkStatusExpired: "Closed",
  homeworkNote: "Score:",
  exerciseList: "Exercise list: ",
  emptyHomeworks: "No assignments assigned.",
  homeworkNumber: "Assignment No.",
  homeworkNumberColon: "Assignment No. {number}:",
  homeworkCompleted: "Assignment completed!",
  mockTestCompleted: "Mock test completed!",
  yourMark: "Your score:",
  backToHomeworks: "Back to my assignments",
  homeworkAttempt: "attempt",
  homeworkAttempts: "attempts",
  gradeUnfinishedHomeworks: "Grade incomplete assignments",
  gradeUnfinishedHomeworksDetails:
    "Students in this class who have not completed a past assignment will be graded based on the answers they have submitted. This action will be applied to all incomplete assignments in this class. This action cannot be undone.",
  adminTeacherHomeworks: "Teacher Assignments",
};

export default assignment;
